import Style from "./css/style.module.css";
import strFunc from '@/lib/lyg/string';
import TodoStateFunc from "@/pcomponents/common/content/todo/state/func/state_func";
import GroupTitleRow from "./group_title";

function MidTodoArea(props: any) {
  let myProps = {
    info: {},
    td_sort_data_arr: [],
    subject_name: "",
    base_date_str: "",
    pre_date_str: "",
    daily_info:null,
    is_view_detail: true,
    openTodoDaySort: (inData: any) => { },
    openTodoWriteOnePopup: (inData: any) => { },
    ...props
  };
  let info = myProps.info;
  let base_date_str = myProps.base_date_str;
  let pre_date_str = myProps.pre_date_str;
  let subject_name = myProps.subject_name;
  let daily_info = myProps.daily_info;

  const get_detail_todo_row_tags = (inData: any) => {
    let opt_obj = {
      todo_info_arr: [],
      ...inData,
    };

    let detail_todo_row_tags = opt_obj.todo_info_arr.map((item: any, idx: number) => {
      let row_stat_data = TodoStateFunc.get_stat_data_by_todo_info(item);
      let todo_color_json = TodoStateFunc.get_color_of_percent(row_stat_data.percent);
      let time_str = row_stat_data.time_str;
      if (strFunc.is_empty(item.a_time_sec)) {
        time_str = "";
      }
      let hover_title_str = item.a_title + "\n내용: " + item.a_content + "\n결과메모: " + item.a_result_memo;
      let title_color = "#0b0000";
      let title_weight = "";
      if (!strFunc.is_empty(item.a_result_memo)) {
        title_color = "#0440a8";
        title_weight = "500";
      }
      return (
        <tr key={idx} className={Style.mid_todo_row_detail_row}>
          <td style={{ paddingLeft: 20 }} title={hover_title_str} onClick={() => {
            myProps.openTodoWriteOnePopup({
              todo_info: item,
              isUpdate: true,
            });
          }}>
            <input type="text" value={item.a_title}
              style={{ width: "100%", border: 0, cursor: "pointer", color: title_color, fontWeight: title_weight, background: "transparent" }} readOnly />
          </td>
          <td style={{ textAlign: "right" }}>
            {time_str}
          </td>
          <td style={{ color: todo_color_json.per, textAlign: "right", paddingRight: 5 }}>
            {row_stat_data.ing_amout}/{row_stat_data.max_amout}
          </td>
        </tr>
      );
    });
    if (strFunc.is_empty(detail_todo_row_tags)) {
      detail_todo_row_tags = (
        <tr>
          <td colSpan={3}>
            <div style={{ color: "#777", textAlign: "center", lineHeight: "20px", fontSize: "13px" }}>
              내용이 없습니다.
            </div>
          </td>
        </tr>
      );
    }
    return detail_todo_row_tags;
  };

  const get_subject_group_tags = (inData: any) => {
    let opt_obj = {
      subject_data_arr: [],
      sort_title: "수업",
      sort: "",
      ...inData
    };
    let subject_data_arr = opt_obj.subject_data_arr;

    let subject_group_tags = subject_data_arr.map((item: any, idx: number) => {
      let detail_todo_tags = get_detail_todo_row_tags(item);

      return (
        <div key={idx} className={Style.mid_todo_row_detail_wrap}>
          <table style={{ width: "100%" }}>
            <colgroup>
              <col width={"70%"}></col>
              <col width={"15%"}></col>
              <col width={"15%"}></col>
            </colgroup>
            <tbody>
              <tr>
                <td colSpan={3}>
                  <GroupTitleRow
                    Style={Style}
                    info={info}
                    sort={opt_obj.sort}
                    sort_title={opt_obj.sort_title}
                    subject_name={subject_name}
                    base_date_str={base_date_str}
                    pre_date_str={pre_date_str}
                    row_item={item}
                    title={item.subject}
                    openTodoDaySort={myProps.openTodoDaySort}
                  ></GroupTitleRow>
                </td>
              </tr>
              {myProps.is_view_detail && detail_todo_tags}
            </tbody>
          </table>
        </div>
      );
    });

    return subject_group_tags;
  };

  const get_todo_row_tag = () => {
    let todo_row_tags = myProps.td_sort_data_arr.map((item: any, idx: number) => {
      let subject_data_json = item.subject_data_json;
      let subject_data_arr: any = [];
      if (subject_data_json) {
        for (let key in subject_data_json) {
          if (!strFunc.is_empty(subject_name)) {
            if (key == subject_name) {
              subject_data_arr.push(subject_data_json[key]);
            }
          } else {
            subject_data_arr.push(subject_data_json[key]);
          }
        }
      }

      //detail
      let todo_detail_tags: any = "";
      if (item.sort == "pre_homework" || item.sort == "homework") {
        if (!strFunc.is_empty(subject_name)) {
          if (subject_data_arr.length > 0) {
            for (let i = 0; i < subject_data_arr.length; i++) {
              subject_data_arr[i].subject = "";
            }
          }
        } else {
          subject_data_arr = [];
          subject_data_arr.push({
            ...item,
            subject: "",
          });
        }

        todo_detail_tags = get_subject_group_tags({
          subject_data_arr: subject_data_arr,
          sort_title: item.title,
          sort: item.sort,
        });
      } else {
        todo_detail_tags = get_subject_group_tags({
          subject_data_arr: subject_data_arr,
          sort_title: item.title,
          sort: item.sort,
        });
      }

      let is_empy_detail = false;
      let empty_subject_name = subject_name;
      if (strFunc.is_empty(todo_detail_tags)) {
        is_empy_detail = true;
        if (myProps.is_view_detail) {
          todo_detail_tags = (
            <div style={{ color: "#777", textAlign: "center", lineHeight: "20px", fontSize: "13px" }}>
              내용이 없습니다.
            </div>
          );
        }
        item = {
          ...item,
          "percent": 0,
          "count": 0,
          "success_cnt": 0,
          "elapse_time_sec": 0,
          "per_arr": [],
          "todo_info_arr": [],
          "file_cnt": 0,
          "file_arr": [],
        };
        if (item.sort == "pre_homework" || item.sort == "homework") {
          empty_subject_name = "";
        }
      }

      return (
        <div key={idx} >
          {is_empy_detail &&
            <GroupTitleRow
              Style={Style}
              info={info}
              sort={subject_name}
              sort_title={item.title}
              subject_name={subject_name}
              base_date_str={base_date_str}
              pre_date_str={pre_date_str}
              daily_info={daily_info}
              row_item={item}
              title={empty_subject_name}
              openTodoDaySort={myProps.openTodoDaySort}
            ></GroupTitleRow>
          }
          <div>
            {todo_detail_tags}
          </div>
        </div>
      );
    });
    return todo_row_tags;
  };

  return (
    <div className={Style.todo_box}>
      {get_todo_row_tag()}
    </div>
  );
}
export default MidTodoArea;